export default __webpack_public_path__ + "static/media/seasonal_fluid.9e6db128.png";